import React, { Component } from 'react'
import PropTypes from 'prop-types'
import injectSheet from 'react-jss'
import classNames from 'classnames'

const styles = () => {
  return {
    container: {
      flexDirection: 'row',
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'space-around',
    },
    tabItem: {
      display: 'flex',
    },
    tabItemButton: {
      color: 'white',
      textDecorationColor: 'white',
      outline: 0,
      border: 0,
      background: 'none',
      paddingLeft: '1vw',
      paddingRight: '1vw',
      cursor: 'pointer',
      opacity: 0.7,
      fontSize: '14px',
      '&:hover': {
        opacity: 1,
        borderBottom: '1px solid white',
      },
    },
    tabItemButtonSelected: {
      borderBottom: '1px solid white',
      fontWeight: 600,
      opacity: 1,
    },
  }
}

@injectSheet(styles)
class TabBar extends Component {
  handleTabItemButtonClick = (index) => {
    return () => {
      const { onChange } = this.props
      if (onChange) {
        onChange(index)
      }
    }
  }

  render() {
    const {
      classes, tabs, selectedTabIndex,
    } = this.props
    return (
      <div className={classes.container}>
        {tabs.map((tab, index) => {
          return (
            <div className={classes.tabItem} key={index}>
              <button
                className={classNames(classes.tabItemButton, {
                  [classes.tabItemButtonSelected]: selectedTabIndex === index,
                })}
                onClick={this.handleTabItemButtonClick(index)}
              >
                {tab.name}
              </button>
            </div>
          )
        })}
      </div>
    )
  }
}

TabBar.propTypes = {
  title: PropTypes.string,
  classes: PropTypes.object,
  description: PropTypes.string,
  rightLabel: PropTypes.node,
  onChange: PropTypes.func,
  tabs: PropTypes.array,
  selectedTabIndex: PropTypes.number,
}

export default TabBar
